export const applyLandscapeMode = async (canvas, ctx, setMessage, language) => {
  // 진행 상황 업데이트
  setMessage(language === 'KR' ? '풍경 모드 적용 중 (1/3) - 색감 강화...' : 'Applying Landscape Mode (1/3) - Enhancing colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 풍경 모드 효과 적용
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 색상 채도 증가 (풍경 모드 특징)
  for (let i = 0; i < data.length; i += 4) {
    // 파란색 및 녹색 강화 (하늘, 나무, 식물)
    data[i + 1] = Math.min(255, data[i + 1] * 1.1); // 녹색 강화
    data[i + 2] = Math.min(255, data[i + 2] * 1.1); // 파란색 강화
    
    // 채도 증가
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = Math.min(255, avg + (data[i] - avg) * 1.2);
    data[i + 1] = Math.min(255, avg + (data[i + 1] - avg) * 1.2);
    data[i + 2] = Math.min(255, avg + (data[i + 2] - avg) * 1.2);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 대비 증가
  setMessage(language === 'KR' ? '풍경 모드 적용 중 (2/3) - 대비 조정...' : 'Applying Landscape Mode (2/3) - Adjusting contrast...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const contrastData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const contrastPixels = contrastData.data;
  
  // 콘트라스트 증가
  const factor = 1.2; // 콘트라스트 강도
  
  for (let i = 0; i < contrastPixels.length; i += 4) {
    for (let c = 0; c < 3; c++) {
      const value = contrastPixels[i + c];
      contrastPixels[i + c] = Math.min(255, Math.max(0, 
        128 + factor * (value - 128)));
    }
  }
  
  ctx.putImageData(contrastData, 0, 0);
  
  // 3. 선명도 향상
  setMessage(language === 'KR' ? '풍경 모드 적용 중 (3/3) - 선명도 향상...' : 'Applying Landscape Mode (3/3) - Enhancing sharpness...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 샤프닝 필터 적용
  const sharpenData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const sharpenPixels = sharpenData.data;
  
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 언샵 마스킹
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const current = tempData[pos + c];
        const top = tempData[pos - canvas.width * 4 + c];
        const bottom = tempData[pos + canvas.width * 4 + c];
        const left = tempData[pos - 4 + c];
        const right = tempData[pos + 4 + c];
        
        // 샤프닝 효과
        sharpenPixels[pos + c] = Math.min(255, Math.max(0, 
          current * 1.8 - (top + bottom + left + right) / 6));
      }
    }
  }
  
  ctx.putImageData(sharpenData, 0, 0);
  
  // 처리 완료
  setMessage(language === 'KR' ? '풍경 모드 적용 완료!' : 'Landscape Mode applied!');
};